<button (click)="onClicked()">Create Group</button>
<app-render-list
  [renderList]="renderList"
  [renderPipelineId]="renderPipelineId | async"
  >
</app-render-list>
<router-outlet/>
